var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSmile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 13.3332C10.222 13.3332 12.8337 10.7215 12.8337 7.49984C12.8337 4.27818 10.222 1.6665 7.00033 1.6665C3.77866 1.6665 1.16699 4.27818 1.16699 7.49984C1.16699 10.7215 3.77866 13.3332 7.00033 13.3332Z",
    stroke: "#25282B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 8.6665C4.66699 8.6665 5.54199 9.83317 7.00033 9.83317C8.45866 9.83317 9.33366 8.6665 9.33366 8.6665",
    stroke: "#25282B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.75H5.25583",
    stroke: "#25282B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.75H8.75583",
    stroke: "#25282B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSmile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/smile.553bcfd3.svg";
export { ForwardRef as ReactComponent };